import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import classNames from "classnames";
import { Drag } from "neetoicons";
import { Checkbox, Label } from "neetoui";

const Item = ({
  column,
  hiddenColumns,
  checkboxProps,
  onToggle,
  isTableConfigurationFetching,
}) => {
  const { key, title } = column;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
    over,
    active,
  } = useSortable({ id: key });

  const dragStyle = {
    transform: isDragging ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const isIndicatorVisible = !isDragging && isOver;
  const draggedIndex = active?.data?.current?.sortable?.index;
  const targetIndex = over?.data?.current?.sortable?.index;

  return (
    <div>
      <div
        className={classNames({
          "neeto-ui-bg-gray-200 h-1 w-full":
            isIndicatorVisible && targetIndex < draggedIndex,
        })}
      />
      <div
        className="neeto-molecules-columns__sortable-item"
        data-testid="column-sortable-item"
        ref={setNodeRef}
        style={dragStyle}
      >
        <Label
          className="neeto-ui-flex neeto-ui-w-full hover:neeto-ui-bg-gray-200 neeto-ui-cursor-pointer neeto-ui-items-center relative px-5 py-2"
          htmlFor={key}
        >
          <div
            {...attributes}
            {...listeners}
            className="neeto-ui-cursor-grab neeto-ui-flex neeto-ui-items-center absolute top-2 left-0.5"
            data-testid="column-drag-handle"
          >
            <Drag
              className="neeto-ui-text-gray-400 hover:neeto-ui-text-gray-500 transition-all duration-300 ease-in-out"
              size={16}
            />
          </div>
          <Checkbox
            checked={!hiddenColumns.includes(key)}
            data-testid="neeto-ui-columns-checkbox"
            disabled={isTableConfigurationFetching}
            id={key}
            label={title}
            name={key}
            onChange={onToggle}
            {...checkboxProps}
          />
        </Label>
      </div>
      <div
        className={classNames({
          "neeto-ui-bg-gray-200 h-1 w-full":
            isIndicatorVisible && targetIndex > draggedIndex,
        })}
      />
    </div>
  );
};

export default Item;
